import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getRevenueStatus = ({ churchId, fromDate, toDate, period }) => {
  return axios.get(
    `/churches/${churchId}/dashboard/revenue-by-chart-of-account?from_date=${fromDate}&to_date=${toDate}&period=${period}`
  );
};

export const useRevenueStatus = ({
  churchId,
  fromDate,
  toDate,
  period,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["revenue-status", churchId, fromDate, toDate, period],
    queryFn: () => getRevenueStatus({ churchId, fromDate, toDate, period }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
